import React from "react";

// Official Vozelto brand mark.
//  - "horizontal": emblem tile + VOZELTO wordmark (+ optional tagline) — use where width allows.
//  - "icon": square V-monogram emblem tile only — use in tight/small areas.
const EMBLEM = "/vozelto-app-icon.png";

export const Logo = ({ variant = "horizontal", height = 32, showTagline = true, className = "", alt = "Vozelto" }) => {
  const emblemSize = Math.round(height * 1.08); // V mark ~8% larger for stronger glance impact
  const emblem = (
    <img src={EMBLEM} alt={variant === "icon" ? alt : ""} draggable={false}
      style={{ height: emblemSize, width: emblemSize }}
      className="select-none rounded-[24%] object-cover ring-1 ring-white/10 shrink-0" />
  );
  if (variant === "icon") {
    return <span data-testid="vozelto-logo-icon" className={className}>{emblem}</span>;
  }
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="vozelto-logo-horizontal" aria-label={alt}>
      {emblem}
      <div className="leading-none">
        <div className="font-head font-extrabold tracking-tight text-white"
          style={{ fontSize: Math.round(height * 0.58), lineHeight: 1 }}>
          <span className="brand-text">V</span>OZELTO
        </div>
        {showTagline && (
          <div className="text-[#8a8a8a] font-semibold mt-1"
            style={{ fontSize: Math.max(7, Math.round(height * 0.145)), letterSpacing: "0.22em" }}>
            THE AI OPERATING SYSTEM
          </div>
        )}
      </div>
    </div>
  );
};

export default Logo;
